import { api } from '../../app/api/baseApi';
import { FeatureFlagObj } from '../../types';

export const featureFlagApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getAllFeatureFlag: builder.query<FeatureFlagObj, any>({
            query: ({ headers }) => {
                return {
                    url: '/v1/api/feature-flags',
                    method: 'GET',
                    ...(headers && { headers }),
                };
            },
            providesTags: ['FeatureFlag'],
        }),
    }),
});

export const { useGetAllFeatureFlagQuery } = featureFlagApi;
